import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import queryString from "query-string";

const BASE_URL = "https://rdfsedar.com/api/data/employee/filter/idnumber";

export const syncUserDataFromSedarApi = createApi({
  reducerPath: "syncUserDataFromSedarApi",
  tagTypes: ["SyncUserDataFromSedar"],
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("withCredentials", false);
      headers.set("Accept", "application/json");
      headers.set("Authorization", `Bearer ${process.env.REACT_APP_SEDAR_KEY}`);
      headers.set("X-Auth-Token", `Bearer ${process.env.REACT_APP_SEDAR_KEY}`);

      return headers;
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: (builder) => ({
    fetchSyncUserDataFromSedar: builder.query({
      query: (params) => ({
        url: "",
        method: "GET",
        params,
      }),
      providesTags: ["SyncUserDataFromSedar"],
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useFetchSyncUserDataFromSedarQuery, useLazyFetchSyncUserDataFromSedarQuery } =
  syncUserDataFromSedarApi;
